import { memo } from 'react';

import { MessageSquareIcon } from '@air/design-icons';
import { tailwindVariants } from '@air/utils-tailwind';

import {
  isWorkspaceAgentSessionNeedsAttention,
  type WorkspaceAgentSessionNeedsAttentionSession,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/isWorkspaceAgentSessionNeedsAttention';

const workspaceAgentMyTasksAttentionDot = tailwindVariants({
  base: 'absolute -top-0.5 -right-0.5 size-1.5 rounded-full ads:bg-ads-amber-9 bg-amber-9 ring-2 transition-shadow duration-150 ease-out',
  variants: {
    isSelected: {
      false: 'ring-gray-1 group-focus-within/row:ring-gray-3 group-hover/row:ring-gray-3',
      true: 'ring-gray-2 group-focus-within/row:ring-gray-4 group-hover/row:ring-gray-4',
    },
  },
});

export type WorkspaceAgentPanelMyTasksRowIconProps = {
  isSelected: boolean;
  session: WorkspaceAgentSessionNeedsAttentionSession;
};

export const WorkspaceAgentPanelMyTasksRowIcon = memo(
  ({ isSelected, session }: WorkspaceAgentPanelMyTasksRowIconProps) => {
    const showAttentionBadge = isWorkspaceAgentSessionNeedsAttention(session);

    return (
      <span className="relative size-5 shrink-0 overflow-visible">
        <span className="flex size-5 items-center justify-center ads:text-icon-subtle text-gray-9">
          <MessageSquareIcon aria-hidden size={14} />
        </span>
        {showAttentionBadge ? (
          <span
            aria-hidden
            className={workspaceAgentMyTasksAttentionDot({ isSelected })}
            data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_ROW_ATTENTION_DOT"
          />
        ) : null}
      </span>
    );
  },
);

WorkspaceAgentPanelMyTasksRowIcon.displayName = 'WorkspaceAgentPanelMyTasksRowIcon';
